import { createStyles, StyleRules } from '@material-ui/core/styles';

export const styles: () => StyleRules = () =>
  createStyles({
    paper: {
      width: '100%',
    },
    content: {
      height: '500px',
      paddingRight: '14px',
      overflowX: 'hidden',
    },
    contentAutoHeight: {
      height: 'auto',
      paddingRight: '14px',
      overflowX: 'hidden',
    },
    contentHeightWithActions: {
      height: '75%',
      flex: 'none',
      paddingRight: '14px',
      overflowX: 'hidden',
      overflowY: 'hidden',
      marginTop: '25px',
    },
    lg: {
      width: '1069px',
    },
    xl: {
      width: '1169px',
      height: '700px',
    },
    xlLimits: {
      width: '1280px',
      height: '600px',
    },
    xs: {
      maxWidth: '466px',
    },
    title: {
      marginTop: '6px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '21px',
      color: '#2C2D3E',
    },
    titlePostscript: {
      marginTop: '6px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 100,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#2C2D3E',
    },
    subtitle: {
      marginTop: '6px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '21px',
      color: '#2C2D3E',
    },
    navButton: {
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '13px',
      color: '#3C419A',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      textDecoration: 'underline',
    },
    navIcon: {
      position: 'relative',
      top: '3px',
    },
  });
